import React from 'react';
import { ComingSoonBannerContainer } from './ComingSoonBanner.style';
import { useTranslations } from '@lang';

export const ComingSoonBanner: React.FC = () => {
  const { t } = useTranslations();
  return <ComingSoonBannerContainer>{t('products.comingSoon')}</ComingSoonBannerContainer>;
};
